document.addEventListener('DOMContentLoaded', function(){
  Support.init();
});

const Support = {
  selectors: {
    "faqDropdowns": { selector: '.faq', type: 'all', scope: 'document' },
    "chatBtn": { selector: '#chat-btn', type: 'single', scope: 'document' },
    "chatBoxBtn": { selector: '#launcher', type: 'single', scope: 'document' }
  },

  init: function() {
    Utility.fetchEls(this.selectors, this);
    this.initEventListeners();
  },

  initEventListeners: function() {
    const { faqDropdowns, chatBtn } = this;

    if (faqDropdowns) {
      faqDropdowns.forEach((dropdown) => {
        dropdown.addEventListener('click', () => {
          this.toggleFaqDropdown(dropdown);
        });
      });
    }

    // Check for the chatBoxBtn iframe every 500ms until it loads
    let chatBoxBtnCheck = setInterval(() => {
      const chatBoxBtn = document.querySelector('#launcher'); // Make sure it selects the iframe
      if (chatBoxBtn) {
        clearInterval(chatBoxBtnCheck); // Stop the interval once found
        this.initChatButton(chatBtn, chatBoxBtn);
      }
    }, 500);
  },

  initChatButton: function(chatBtn, chatBoxBtn) {
    if (chatBtn && chatBoxBtn) {
      chatBtn.addEventListener('click', () => {
        const button = chatBoxBtn.contentWindow.document.querySelector('button[shape="circle"]');
        if (button) {
          button.click();
        }
      });
    }
  },

  toggleFaqDropdown: function(dropdown) {
    if (dropdown.classList.contains('expanded')) {
      dropdown.classList.remove('expanded');
    } else {
      dropdown.classList.add('expanded');
    }
  }
};